var productionMode = false;
const urlStart = 'https://sasmoid-stock-dash.qtrust.id';

export default {productionMode , urlStart};
